export const excludedCountriesList = ['il', 'ca', 'us', 'kz', 'do', 'pr'];
